import {
  SECTION_TYPE_CUSTOM_SECTION,
  SECTION_TYPE_MEASUREMENT_SECTION,
  SECTION_TYPE_WEIGHT_SECTION,
} from '@/constant/qsf'

export const TemplateManagementConstant = {
  DEFAULT_SECTION: {
    name: '',
    index: 0,
    title: '',
    options: { type: 'CUSTOM_SECTION', instruction: '' },
    sub_sections: [],
  },

  DEFAULT_SUB_SECTION: {
    name: '',
    index: 0,
    title: '',
    checkpoints: [],
    options: { isGsm: true },
  },

  DEFAULT_CHECKPOINT: {
    name: '',
    index: 0,
    title: '',
    options: { is_multi: true },
    data_source: [],
    validations: { is_required: true },
    control_type: '',
  },
}

export const INSPECTION_SECTION_TYPES = [
  {
    label: 'Custom Section',
    value: SECTION_TYPE_CUSTOM_SECTION,
  },
  {
    label: 'Measurement Section',
    value: SECTION_TYPE_MEASUREMENT_SECTION,
  },
  {
    label: 'Workmanship Section',
    value: 'WORKMANSHIP_SECTION',
  },
  {
    label: 'Weight Section',
    value: SECTION_TYPE_WEIGHT_SECTION,
  },
]

export const HAS_CONCLUSIONS = [
  {
    label: 'Yes',
    value: 'YES',
  },
  {
    label: 'No',
    value: 'NO',
  },
]

export const HAS_CONCLUSIONS_OBJECT = {
  YES: {
    label: 'Yes',
    value: 'YES',
  },
  NO: {
    label: 'No',
    value: 'NO',
  },
}

export const SUB_SECTION_TYPE = [
  {
    label: 'List of Checkpoints (Standard)',
    value: 'STANDARD',
  },
  {
    label: 'Group of Checkpoints (Table)',
    value: 'GROUP',
  },
]
export const SUB_SECTION_TYPE_OBJECT = {
  STANDARD: {
    label: 'List of Checkpoints (Standard)',
    value: 'STANDARD',
  },
  GROUP: {
    label: 'Group of Checkpoints (Table)',
    value: 'GROUP',
  },
}

export const CHECKPOINT_TYPES = [
  {
    label: 'Yes',
    value: 'YES',
  },
  {
    label: 'Yes',
    value: 'YES',
  },
]

export const CHECKPOINTS_TYPES = [
  {
    label: 'Text',
    value: 'text',
  },
  {
    label: 'Number',
    value: 'number',
  },
  // {
  //   label: 'Number Integer',
  //   value: 'integer',
  // },
  {
    label: 'Photo',
    value: 'photo',
  },
  {
    label: 'Date',
    value: 'date',
  },
  {
    label: 'Single Choice - Button List',
    value: 'select',
  },
  {
    label: 'Single Choice - Page List',
    value: 'select_dropdown',
  },
  {
    label: 'Multiple Choice - Checkboxes',
    value: 'multi_select',
  },
  {
    label: 'Editable Choice - Entry List',
    value: 'editable_entry_list',
  },
]
